// Generate code from clean architecture template

import { QueryCourseTopicPayload, QueryCourseTopicsOutput } from '../ports/payloads';
import { CourseTopicRepository } from '../ports/repositories';

export class GetListCourseTopicUsecase {
  constructor(private readonly repo: CourseTopicRepository) {}

  async run(payload?: QueryCourseTopicPayload): Promise<QueryCourseTopicsOutput> {
    const data = await this.repo.getListCourseTopic(payload);
    return data;
  }
}
